module.exports = __webpack_public_path__ + "static/media/stageWithLogo.37842a9a.jpg";